import { createFileRoute } from '@tanstack/react-router';
import EmployeePortalApp from '../../components/portals/employees/EmployeePortalApp';
import { RequireRole } from '../../components/site/RequireRole';

export const Route = createFileRoute('/portal/employees')({
  component: EmployeesPortalRoute,
});

function EmployeesPortalRoute() {
  return (
    <RequireRole role="employee">
      <EmployeePortalApp />
    </RequireRole>
  );
}
